import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { FormControlLabel } from "@mui/material";
import TextField from "@mui/material/TextField";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { List, useDataGrid } from "@refinedev/mui";
import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { UpdateExpirationDate } from "./updateExpirationDate";

const PAGESIZE = 100;

export const UserBadgesList = () => {
  const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
    pagination: {
      pageSize: PAGESIZE,
    },
  });

  const timeReverse = (date: any) => {
    const Y = date.getFullYear() + "-";
    const M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    const D =
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "";
    return Y + M + D;
  };

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 100,
        hideable: false,
      },
      {
        field: "userId",
        headerName: "UserId",
        minWidth: 100,
        hideable: false,
      },
      {
        field: "uuid",
        headerName: "Uuid",
        minWidth: 100,
        hideable: false,
      },
      {
        field: "email",
        headerName: "Email",
        minWidth: 300,
        hideable: false,
      },
      {
        field: "badgeName",
        headerName: "Badge Name",
        minWidth: 300,
        hideable: false,
      },
      {
        field: "expirationDate",
        headerName: "Expiration Date",
        minWidth: 250,
        hideable: false,
      },
      {
        field: "expirationDateOfOriginalBadge",
        headerName: "Expiration Date Of Original Badge",
        minWidth: 300,
        hideable: false,
      },
    ],
    []
  );

  // search parts
  const [userId, setUserId] = useState("");
  const [uuid, setUuid] = useState("");
  const [email, setEmail] = useState("");
  const [badgeName, setBadgeName] = useState("");
  const [expirationDate, setExpirationDate] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (userId) {
      searchArr.push({
        field: "userId",
        value: `${userId}`,
        operator: "eq",
      });
    }
    if (uuid) {
      searchArr.push({
        field: "uuid",
        value: `${uuid}`,
        operator: "eq",
      });
    }
    if (email) {
      searchArr.push({
        field: "email",
        value: `${email}`,
        operator: "eq",
      });
    }
    if (badgeName) {
      searchArr.push({
        field: "badgeName",
        value: `${badgeName}`,
        operator: "eq",
      });
    }
    if (expirationDate) {
      searchArr.push({
        field: "expirationDate",
        value: `${timeReverse(expirationDate?.["$d" as any])}`,
        operator: "eq",
      });
    }
    setFilters(searchArr as any);
  };

  const clearFun = () => {
    setUserId("");
    setUuid("");
    setEmail("");
    setBadgeName("");
    setExpirationDate(null);
    setFilters([]);
    setPageSize(PAGESIZE);
  };

  const handleSelectionChange = (ids: any[]) => {
    const selected = dataGridProps.rows.filter((row: any) =>
      ids.includes(row.id)
    );
    setSelectedRows(selected);
  };

  return (
    <List>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="User ID"
                variant="standard"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                style={{ width: "30%" }}
              />
              <TextField
                id="standard-basic"
                label="Uuid"
                variant="standard"
                value={uuid}
                onChange={(e) => setUuid(e.target.value)}
                style={{ width: "30%" }}
              />
              <TextField
                id="standard-basic"
                label="Email"
                variant="standard"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: "30%" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="Badge Name"
                variant="standard"
                value={badgeName}
                onChange={(e) => setBadgeName(e.target.value)}
                style={{ width: "30%" }}
              />
              <DatePicker
                label="Expiration Date"
                value={expirationDate}
                slotProps={{ textField: { style: { width: "30%" } } }}
                onChange={setExpirationDate}
              />
              <div
                style={{ width: "30%", display: "flex", alignItems: "center" }}
              >
                <ClearOutlinedIcon
                  onClick={clearFun}
                  style={{ marginRight: "10px" }}
                />
                <SearchIcon
                  onClick={handleFilter}
                  style={{ marginRight: "20px" }}
                />
                <div style={{ marginLeft: "auto" }}>
                  <UpdateExpirationDate
                    selectedRows={selectedRows}
                    refresh={() => {
                      setFilters((prev) => [
                        ...prev.filter(
                          (filter: any) =>
                            !filter.field.startsWith("refreshTrigger")
                        ),
                        {
                          field: `refreshTrigger_${Date.now()}`,
                          operator: "eq",
                          value: "true",
                        },
                      ]);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        }
      />
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        paginationMode="server"
        rowsPerPageOptions={[PAGESIZE]}
        disableColumnFilter
        checkboxSelection
        onSelectionModelChange={(newSelection) =>
          handleSelectionChange(newSelection)
        }
      />
    </List>
  );
};
